import { format, startOfMonth, subMonths } from "date-fns";

/**
 * Generate an array of month options for filtering based on a date preset key.
 * @param {string} presetKey - The selected preset (e.g., 'last_quarter').
 * @returns {Array<{value: string, label: string}>} - An array of month objects.
 */
export const generateMonthOptions = (presetKey) => {
  
  if (!presetKey) return [];

  const today = new Date();
  let numberOfMonths;

  switch (presetKey) {
    case "last_week":
    case "last_month":
      numberOfMonths = 2; // Current and previous month
      break;
    case "last_quarter":
      numberOfMonths = 4; // Current and 3 previous months
      break;
    case "last_6_months":
      numberOfMonths = 7; // Current and 6 previous months
      break;
    case "last_year":
      numberOfMonths = 13; // Current and 12 previous months
      break;
    default:
      return []; // Don't show month filter for unsupported presets
  }

  const months = [];
  for (let i = 0; i < numberOfMonths; i++) {
    const targetDate = startOfMonth(subMonths(today, i));
    months.push({
      value: format(targetDate, "yyyy-MM"), // e.g., "2025-08"
      label: format(targetDate, "MMMM yyyy"), // e.g., "August 2025"
    });
  }

  return months;
};